module.exports = __webpack_public_path__ + "static/media/4.3000167.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/4.wav
// module id = SRwP
// module chunks = 0